import React, { ReactNode } from "react"
import { Panel, Title, Text, Button } from "dash-styled"

interface AppStatusBannerTemplateProps {
    title: string
    bgColor: string
    icon: ReactNode
    message?: ReactNode
    suppressPanelClick?: boolean
    action?: [string, (() => void) | undefined]
}

export function AppStatusBannerTemplate({
    title,
    icon,
    message,
    action,
    bgColor,
    suppressPanelClick = false
}: AppStatusBannerTemplateProps) {
    const buttonLabel = action === undefined ? undefined : action[0]
    const handleAction = action === undefined ? undefined : action[1]

    return (
        <div
            className={[
                "mb-4",
                handleAction === undefined || suppressPanelClick
                    ? ""
                    : "cursor-pointer"
            ].join(" ")}
            onClick={suppressPanelClick ? undefined : handleAction}
        >
            <Panel
                testId="app-status-banner"
                size="sm"
                className="flex items-center justify-stretch"
                style={{ backgroundColor: bgColor }}
            >
                <Text
                    color="darkviolet"
                    component="span"
                    className={[
                        message === undefined ? "" : "self-start",
                        "mr-3"
                    ].join(" ")}
                >
                    {icon}
                </Text>
                <div className="flex-grow flex flex-col lg:flex-row items-start lg:items-center justify-between">
                    <div className="flex-grow">
                        <Title
                            component="h2"
                            variant="heading2"
                            color="white"
                            noMargin={true}
                            className="text-xl"
                        >
                            {title}
                        </Title>
                        {message === undefined ? null : (
                            <Text
                                component="div"
                                className="pt-1 opacity-75"
                                weight="regular"
                                color="white"
                            >
                                {message}
                            </Text>
                        )}
                    </div>
                    {buttonLabel && (
                        <Button
                            className="w-auto py-3 border-none mt-2 bl-0 lg:mt-0 lg:ml-4 text-grape-900"
                            onClick={handleAction}
                            variant="contained2"
                            color="plain"
                            disabled={handleAction === undefined}
                        >
                            {buttonLabel}
                        </Button>
                    )}
                </div>
            </Panel>
        </div>
    )
}
